export default __webpack_public_path__ + "static/MINCLUSIONJARSCOTTONPOUCH_600x600-cb6254a3c66d4c98fd8626a5f565828e.png";